'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _some2 = require('lodash/some');

var _some3 = _interopRequireDefault(_some2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _reactRouter = require('react-router');

var _urijs = require('urijs');

var _urijs2 = _interopRequireDefault(_urijs);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _utils = require('@mighty-justice/utils');

var _AppConstants = require('../../../constants/AppConstants');

var _AppConstants2 = _interopRequireDefault(_AppConstants);

var _common = require('../../common');

var _util = require('../../../utils/util');

var _utils2 = require('../../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var MODEL_TYPES = _AppConstants2.default.MODEL_TYPES;
var ShareableDocumentTable = (_dec = (0, _mobxReact.inject)('CaseStore', 'Clients', 'FunderStore', 'LienStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(ShareableDocumentTable, _Component);

  function ShareableDocumentTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ShareableDocumentTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ShareableDocumentTable.__proto__ || Object.getPrototypeOf(ShareableDocumentTable)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'checkedDocumentIds', _descriptor, _this), _initDefineProp(_this, 'isShareModalShowing', _descriptor2, _this), _initDefineProp(_this, 'isSharingRegistryDocuments', _descriptor3, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ShareableDocumentTable, [{
    key: 'setCheckedDocumentIds',
    value: function setCheckedDocumentIds(checkedIds) {
      this.checkedDocumentIds = checkedIds;
    }
  }, {
    key: 'handleShareRegistryDocumentsClick',
    value: function handleShareRegistryDocumentsClick() {
      if (!this.checkedDocumentIds.length) {
        _utils2.toast.error('Select some documents to share!');
      } else {
        this.isShareModalShowing.setTrue();
      }
    }
  }, {
    key: 'handleShareDocumentsClick',
    value: function handleShareDocumentsClick() {
      var documentType = this.props.documentType,
          location = _reactRouter.browserHistory.getCurrentLocation(),
          segments = new _urijs2.default(location.pathname).segment(),
          newURL = _urijs2.default.joinPaths('/', segments[0], segments[1], 'share-' + documentType + '-documents').pathname();


      _reactRouter.browserHistory.push({ pathname: newURL, state: { checkedDocumentIds: this.checkedDocumentIds } });
    }
  }, {
    key: 'onShareClick',
    value: function onShareClick() {
      if (this.props._case.registry_case) {
        this.handleShareRegistryDocumentsClick();
      } else {
        this.handleShareDocumentsClick();
      }
    }
  }, {
    key: 'onShareDocumentsToRegistry',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _props, _case, CaseStore, documents, fetchDocumentsMethod, shareToRegistryMethod, documentIdsToShare;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.isSharingRegistryDocuments.setTrue();
                _props = this.props, _case = _props._case, CaseStore = _props.CaseStore, documents = _props.documents, fetchDocumentsMethod = _props.fetchDocumentsMethod, shareToRegistryMethod = _props.shareToRegistryMethod;
                documentIdsToShare = this.checkedDocumentIds.filter(function (documentId) {
                  return !documents.find(function (document) {
                    return document.id === documentId;
                  }).registry_document;
                });

                // istanbul ignore next

                if (documentIdsToShare.length) {
                  _context.next = 8;
                  break;
                }

                // eslint-disable-next-line
                _utils2.toast.error("You've already shared these documents in the law firm portal!");
                this.isShareModalShowing.setFalse();
                this.isSharingRegistryDocuments.setFalse();
                return _context.abrupt('return');

              case 8:
                _context.prev = 8;
                _context.next = 11;
                return shareToRegistryMethod({ case_id: _case.id, document_ids: documentIdsToShare });

              case 11:
                _context.next = 13;
                return Promise.all([fetchDocumentsMethod(_case.id), CaseStore.caseActivities.loadNew(MODEL_TYPES.documentsSharedToRegistry.key)]);

              case 13:

                this.isShareModalShowing.setFalse();
                _utils2.toast.success('Success! Documents shared to law firm portal!');
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](8);
                throw _context.t0;

              case 20:
                _context.prev = 20;

                this.isSharingRegistryDocuments.setFalse();
                return _context.finish(20);

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[8, 17, 20, 23]]);
      }));

      function onShareDocumentsToRegistry() {
        return _ref2.apply(this, arguments);
      }

      return onShareDocumentsToRegistry;
    }()
  }, {
    key: 'renderShareDocument',
    value: function renderShareDocument() {
      var _props2 = this.props,
          _case = _props2._case,
          documentType = _props2.documentType,
          FunderStore = _props2.FunderStore,
          isRegistryCase = FunderStore.isRegistryEnabled && _case.migrate_to_registry,
          isDisabled = isRegistryCase ? !_case.registry_case : !this.hasCaseContactWithEmail,
          tooltipProps = isDisabled ? { 'data-for': 'bulk-share-' + documentType + '-documents', 'data-tip': true } : {},
          tooltipText = isRegistryCase ? 'We cannot share documents with law firm portal until the case has been shared' : 'You need at least one contact with an email to share documents.';


      return _react2.default.createElement(
        'div',
        tooltipProps,
        _react2.default.createElement(
          _reactTooltip2.default,
          { id: 'bulk-share-' + documentType + '-documents', type: 'info', effect: 'solid', place: 'right' },
          _react2.default.createElement(
            'div',
            null,
            tooltipText
          )
        ),
        _react2.default.createElement(
          _common.LinkButton,
          { disabled: isDisabled, id: 'share-documents', onClick: this.onShareClick },
          _react2.default.createElement(_common.Icon, { type: 'share' }),
          ' Share'
        )
      );
    }
  }, {
    key: 'renderShareMessage',
    value: function renderShareMessage() {
      return _react2.default.createElement(
        'div',
        null,
        'This will share the selected documents with the linked law firm in the law firm portal, are you sure?',
        _react2.default.createElement(_common.Spacer, { large: true })
      );
    }
  }, {
    key: 'renderActions',
    value: function renderActions() {
      if (!this.props.documents.length) {
        return;
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_common.ConfirmDelete, {
          confirmButtonText: this.isSharingRegistryDocuments.isTrue ? 'Sharing...' : 'Confirm',
          element: _common.MessageModal,
          loading: this.isSharingRegistryDocuments.isTrue,
          message: this.renderShareMessage(),
          onClickDelete: this.onShareDocumentsToRegistry,
          onClickCancel: this.isShareModalShowing.setFalse,
          showConfirmDelete: this.isShareModalShowing.isTrue
        }),
        this.renderShareDocument()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          _case = _props3._case,
          columns = _props3.columns,
          registryDocumentRow = {
        accessor: 'registry_document',
        Cell: function Cell(row) {
          return row.value ? 'Yes' : 'No';
        },
        className: 'col-style-gray',
        Header: 'Shared',
        width: 80
      };


      return _react2.default.createElement(_common.DocumentTable, _extends({}, this.props, {
        columns: [].concat(_toConsumableArray(columns), _toConsumableArray((0, _utils.insertIf)(_case.registry_case, registryDocumentRow))),
        onCheck: this.setCheckedDocumentIds,
        renderActions: this.renderActions,
        selectable: true
      }));
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'hasCaseContactWithEmail',
    get: function get() {
      var _case = this.props._case,
          caseContacts = (0, _util.getContactsFromCase)(_case);


      return (0, _some3.default)(caseContacts, function (contact) {
        return contact.email;
      });
    }
  }]);

  return ShareableDocumentTable;
}(_react.Component), _class3.propTypes = {
  _case: _propTypes2.default.object,
  CaseStore: _propTypes2.default.object,
  columns: _propTypes2.default.array,
  documents: _propTypes2.default.array,
  documentType: _propTypes2.default.string,
  FunderStore: _propTypes2.default.object
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'checkedDocumentIds', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'isShareModalShowing', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _utils2.SmartBool();
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'isSharingRegistryDocuments', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _utils2.SmartBool();
  }
})), _class2)) || _class) || _class) || _class);
var _default = ShareableDocumentTable;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(MODEL_TYPES, 'MODEL_TYPES', '/app/src/components/page-case/main-documents/ShareableDocumentTable.js');
  reactHotLoader.register(ShareableDocumentTable, 'ShareableDocumentTable', '/app/src/components/page-case/main-documents/ShareableDocumentTable.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-documents/ShareableDocumentTable.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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